import { ObstacleSide } from './ObstacleSide';
export class RightObstacleSide extends ObstacleSide {
    constructor(startVertex) {
        super(startVertex);
        this.end = startVertex.prevOnPolyline.point;
    }
    get End() {
        return this.end;
    }
    get EndVertex() {
        return this.StartVertex.prevOnPolyline;
    }
}
//# sourceMappingURL=RightObstacleSide.js.map